<script lang="ts">
    import { getContext } from "svelte"
    import Loader from "../../../lib/Loader.svelte"
    import { PhoneNumberFormat } from "../../../lib/golang-models/maindb"
    import { telephonySystems } from "../../../lib/models"
    import Form from "../../../widgets/Form.svelte"
    import Table from "../../../widgets/Table.svelte"
    import TableSorter from "../../../widgets/TableSorter.svelte"
    import PageFooter from "../../elements/PageFooter.svelte"

    const i18n: any = getContext("i18n"),
        modal: any = getContext("modal")

    var formMode: "none" | "edit" | "add" = "none",
        formRecord: PhoneNumberFormat = null
</script>

<Loader endpoint="phone-number-format/list" let:data let:reload>
    {#if formMode == "none"}
        <!-- List -->
        <Table>
            <tr slot="head">
                <th>ID <TableSorter /></th>
                <th>{i18n.translate("dict.name")} <TableSorter /></th>
                <th>Regex</th>
                <th>Keywords</th>
                <th>{i18n.translate("dict.telephony-system")}</th>
                <th>{i18n.translate("dict.actions")}</th>
            </tr>

            {#each data as record}
                <tr>
                    <td>{record.Id}</td>
                    <td>{record.Name}</td>
                    <td>{record.Regex}</td>
                    <td>{record.Keys}</td>
                    <td>{record.TelephonySystem in telephonySystems ? telephonySystems[record.TelephonySystem].label : ""}</td>
                    <td>
                        <a
                            href="#edit"
                            on:click|preventDefault={() => {
                                formRecord = { ...record }
                                formMode = "edit"
                            }}><i class="fa-solid fa-pencil" /></a
                        >
                        <a href="#remove" on:click|preventDefault={() => confirm(i18n.translate("question.remove-item", { item: record.Name })) && modal.post("phone-number-format/remove/" + record.Id).then((r) => r.status == 200 && reload())}><i class="fa-solid fa-trash" /></a>
                    </td>
                </tr>
            {/each}
        </Table>

        <PageFooter>
            <expander />
            <button on:click={() => reload()}><i class="fa-solid fa-refresh" /> {i18n.translate("action.refresh")}</button>
            <button
                on:click={() => {
                    formRecord = new PhoneNumberFormat({ Keys: "tech,cc,ac,number".split(","), Regex: "(\\d*)(0|55)([1-9][1-9])(9\\d{8})" })
                    formMode = "add"
                }}><i class="fa-solid fa-plus" /> {i18n.translate("action.add")} {i18n.translate("dict.format")}</button
            >
        </PageFooter>
    {:else}
        <Form
            submit={() =>
                modal.post(`phone-number-format/save`, formRecord).then((res) => {
                    if (res.status != 200) return
                    formMode = "none"
                    reload()
                })}
        >
            <svelte:fragment slot="title">{i18n.translate("action." + formMode)} {i18n.translate("dict.format")}</svelte:fragment>

            {#if formMode == "edit"}
                <label>
                    ID
                    <input disabled value={formRecord.Id} />
                </label>
            {/if}
            <label>
                {i18n.translate("dict.name")}*
                <input autocomplete="off" bind:value={formRecord.Name} required />
            </label>

            <label>
                Regex*
                <input bind:value={formRecord.Regex} required />
            </label>

            <label>
                Keywords*
                <input value={formRecord.Keys.join(",")} on:change={(e) => (formRecord.Keys = e.currentTarget.value.split(","))} required />
            </label>

            <label>
                {i18n.translate("dict.telephony-system")}
                <select bind:value={formRecord.TelephonySystem}>
                    <option value="">{i18n.translate("dict.none")}</option>
                    {#each Object.keys(telephonySystems) as ns}
                        <option value={ns}>{telephonySystems[ns].label}</option>
                    {/each}
                </select>
            </label>

            <svelte:fragment slot="footer">
                <PageFooter>
                    <expander />
                    <button type="button" class="cancel" on:click={() => (formMode = "none")}><i class="fa-solid fa-pencil" /> {i18n.translate("action.cancel")}</button>
                    <button type="submit" class="primary"><i class="fa-solid fa-floppy-disk" /> {i18n.translate("dict.save")}</button>
                </PageFooter>
            </svelte:fragment>
        </Form>
    {/if}
</Loader>
